import React from "react";
import { Link } from "react-router-dom";
import {
  dashboardCtaClassNames,
  DASHBOARD_CTA_CHIP_CLASS,
  DASHBOARD_CTA_LINK_CLASS,
} from "../InputField/dashboardCtaClassNames";

/**
 * Dashboard CTA — pill primary/secondary (lg/md/sm), chip, or link.
 * Link variant: use `to` (router) or `href` (anchor). Sentence case in copy.
 */
const DashboardCta = ({
  variant = "primary",
  size = "md",
  tone,
  to,
  href,
  children,
  className = "",
  disabled,
  type = "button",
  ...rest
}) => {
  const resolvedTone = tone || (variant === "secondary" ? "secondary" : "primary");

  if (variant === "link") {
    const linkClass = `${DASHBOARD_CTA_LINK_CLASS} ${className}`.trim();
    if (to) {
      return (
        <Link to={to} className={linkClass} {...rest}>
          {children}
        </Link>
      );
    }
    if (rest.onClick != null && href == null) {
      return (
        <button type={type} className={linkClass} disabled={disabled} {...rest}>
          {children}
        </button>
      );
    }
    return (
      <a href={href || "#"} className={linkClass} {...rest}>
        {children}
      </a>
    );
  }

  if (variant === "chip") {
    return (
      <button
        type={type}
        disabled={disabled}
        className={`${DASHBOARD_CTA_CHIP_CLASS} disabled:opacity-50 disabled:cursor-not-allowed ${className}`.trim()}
        {...rest}
      >
        {children}
      </button>
    );
  }

  const btnClass = `${dashboardCtaClassNames({ variant, size, tone: resolvedTone })} disabled:opacity-50 disabled:cursor-not-allowed ${className}`.trim();

  return (
    <button
      type={type}
      disabled={disabled}
      className={btnClass}
      {...rest}
      onClick={disabled ? undefined : rest.onClick}
    >
      {children}
    </button>
  );
};

export default DashboardCta;
